import {get,post} from './httpApi';
import {getUserId,getShopId} from '@/utils/auth'
/*用户获取名人列表*/
export function getCelebrityPage(data){
    return get('/shop/noJwt/getCelebrityPage',{
        longitude:104.072687,
        latitude:30.576222,
        ...data
    })
}

/*用户获取店铺列表*/
export function getShopPageList(data){
    return get('/shop/noJwt/getShopPage',{
        longitude:104.072687,
        latitude:30.576222,
        ...data
    })
}
/*用户获取店铺详情,其实就是获取名人信息 ，名人即店铺*/
export function getShopInfoForUser(shopId){
    let params = {
        shopId
    }
    if(getUserId()){
        params.userId=getUserId()
    }
    return get('/shop/noJwt/getShopInfoForUser',params)
}

/*关注/取消店铺*/
export function setShopFollow(data){
    return  post('/shop/follow',{
        ...data,
        userId:getUserId()
    })
}

/*关注/取消店铺*/
export function isShopFollow(shopId){
    let params = {
        shopId
    }
    if(getUserId()){
        params.userId=getUserId()
    }
    return  post('shop/isFollow',params)
}

/*获取关注-粉丝列表*/
export function getUserForFollowPage(data){
    return get('/shop/getUserForFollowPage',{
        ...data
    })
}
/*店铺获取自己的名人申请信息*/
export function getCelebrityExamineInfo(){
    return get('/shop/getCelebrityExamineInfo',{
        shopId:getShopId()
    })
}
/*获取名人申请条件*/
export function getCelebrityList(data){
    return post('/shop/getCelebrityList',{
        ...data
    })
}
/*提交名人申请*/
export function submitCelebrityExamine(data){
    return post('/shop/submitCelebrityExamine',{
        ...data,
        shopId:getShopId()
    })
}
/*再次提交名人申请*/
export function keepSubmitCelebrityExamine(id){
    return post('/shop/keepSubmitCelebrityExamine',{
        id,
        shopId:getShopId()
    })
}
/*用户获取自己店铺申请的信息*/
export function getShopExamineInfo(){
    return get('/shop/getShopExamineInfo',{
        userId:getUserId()
    })
}
/*提交商家申请*/
export function shopSubmit(data){
    return post('/shop/submit',{
        longitude:104.072687,
        latitude:30.576222,
        userId:getUserId(),
        ...data
    })
}
/*再次提交商家申请*/
export function shopKeepSubmit(data){
    return post('/shop/keepSubmit',{
        longitude:104.072687,
        latitude:30.576222,
        userId:getUserId(),
        ...data
    })
}
/*店铺获取自己的管理信息*/
export function getShopInfoForMe(){
    return get('/shop/getShopInfoForMe',{
        shopId:getShopId()
    })
}
/*店铺营收详情*/
export function getShopMoneyInfo(data){
    return get('/shop/getShopMoneyInfo',{
        shopId:getShopId(),
        ...data
    })
}
/*店铺获取流水*/
export function getShopMoneyLogPage(data){
    return get('/shop/getShopMoneyLogPage',{
        ...data
    })
}
/*獲取我拉黑的用戶列表*/
export function getMyPullBlackPage(data){
    return get('/shop/getMyPullBlackPage',{
        ...data
    })
}
/*拉黑用戶*/
export function pullBlack(data){
    return get('/shop/pullBlack',{
        ...data
    })
}
/*取消拉黑用戶*/
export function cancelPullBlack(data){
    return post('/shop/cancelPullBlack',{
        ...data
    })
}
/*修改自己店铺-名人信息*/
export function shopEdit(data){
    return post('/shop/edit',{
        ...data
    })
}
/*申请提现*/
export function addShopApply(money){
    return post('/shop/addShopApply',{
        money,
        shopId:getShopId()
    })
}